import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import { useState, useEffect } from 'react';
import { ScriptCache } from '../libraries/ScriptCache';
import GoogleApi from '../libraries/GoogleApi';

var createScriptCache = function createScriptCache(options) {
  options = options || {};
  var apiKey = options.apiKey;
  var libraries = options.libraries || ['places'];
  var version = options.version || '3';
  var language = options.language || 'en';
  var url = options.url;
  var client = options.client;
  var region = options.region;
  return ScriptCache({
    google: GoogleApi({
      apiKey: apiKey,
      language: language,
      libraries: libraries,
      version: version,
      url: url,
      client: client,
      region: region
    })
  });
};

var defaultGoogleApiState = {
  loading: true,
  google: null,
  error: null
};
/**
 * @param {string} apiKey
 * @return {import('./types').GoogleAPIState}
 */

var useGoogleAPI = function useGoogleAPI(apiKey) {
  var _useState = useState(defaultGoogleApiState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var onGoogleScriptLoaded = function onGoogleScriptLoaded() {
    setState({
      loading: false,
      error: null,
      google: window.google
    });
  };

  useEffect(function () {
    createScriptCache({
      apiKey: apiKey
    }).google.onLoad(onGoogleScriptLoaded);
  }, [apiKey]);
  return state;
};

export default useGoogleAPI;